/**
 * The collection description shows only its first paragraph by default
 * (theme.css `.collection-header__description p + p`) so long copy doesn't
 * push the product grid below the fold, while still reading as a complete
 * thought instead of being cut off mid-line. The "Read more" button only
 * makes sense when there's a second paragraph to reveal.
 */
(function () {
  document.querySelectorAll('[data-description-wrap]').forEach((wrap) => {
    const text = wrap.querySelector('[data-description]');
    const toggle = wrap.querySelector('[data-description-toggle]');
    if (!text || !toggle) return;

    if (text.querySelectorAll('p').length <= 1) return;

    toggle.hidden = false;
    toggle.addEventListener('click', () => {
      const expanded = text.classList.toggle('is-expanded');
      toggle.textContent = expanded ? 'Show less' : 'Read more';
    });
  });
})();
